import { Attachment, DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutCompanyImage extends Layout {
    attachmentCompanyImage: Attachment;
    sourceCompany: DataSource;
}
